module.exports = __webpack_public_path__ + "static/media/anjan_bharadwaj.ee992090.jpeg";